import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { NgPaginatorComponent } from "./ng-paginator.component";
import { NgOnlyNumberModule } from "../../ng-directives/ng-only-number/ng-only-number.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgOnlyNumberModule
    ],
    declarations: [
        NgPaginatorComponent
    ],
    exports: [
        NgPaginatorComponent
    ]
})
export class NgPaginatorModule { }
